import { useEffect } from 'react';
import { useWarnAboutChange } from '@refinedev/core';

/** Integrates RHF dirty state with Refine's route and browser leave notifier. */
export function useUnsavedGuard(dirty: boolean) {
  const { setWarnWhen } = useWarnAboutChange();
  useEffect(() => {
    setWarnWhen(dirty);
    return () => setWarnWhen(false);
  }, [dirty, setWarnWhen]);
}
